export const UPDATE_BILLING_DATA = (state, val) => {
  state.billingData = val;
};

export const UPDATE_BANK_ACCOUNT_DATA = (state, val) => {
  state.bankAccount = val;
}

export const CARDS_REQUEST_DISPATCH = (state) => {
  state.status = 'requested';
};

export const CARDS_REQUEST_SUCCESS = (state) => {
  state.status = 'success';
};

export const CARDS_REQUEST_ERROR = (state) => {
  state.status = 'error';
};
